<template>
  <v-app>
    <v-app-bar app color="rowReply">
      <router-link to="/" class="d-flex align-center text-decoration-none">
        <img src="/img/Harvia_sauna_spa-logo.svg" alt="Harvia" height="66px" class="mr-2" />
      </router-link>
      <v-spacer></v-spacer>
      <v-btn v-if="showStartNewChat" :icon="$vuetify.breakpoint.smAndDown" :x-large="$vuetify.breakpoint.mdAndUp" text color="primary" @click="startNewChat">
        <v-icon :left="$vuetify.breakpoint.mdAndUp">mdi-chat-plus</v-icon>
        <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('start_new_chat') }}</span>
      </v-btn>
      <v-btn :icon="$vuetify.breakpoint.smAndDown" :x-large="$vuetify.breakpoint.mdAndUp" text color="primary" target="_blank" :href="`https://support.harvia.com/hc/${$i18n.locale}/requests/new/`">
        <v-icon :left="$vuetify.breakpoint.mdAndUp">mdi-face-agent</v-icon>
        <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('leave_contact_request') }}</span>
      </v-btn>
      <v-btn :icon="$vuetify.breakpoint.smAndDown" :x-large="$vuetify.breakpoint.mdAndUp" text color="primary" @click="showLanguageSelector">
        <v-icon :left="$vuetify.breakpoint.mdAndUp">mdi-earth</v-icon>
        <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('language_selector.lang.' + $i18n.locale) }} / {{ $t('language_selector.regions.' + activeRegion) }}</span>
      </v-btn>
    </v-app-bar>
    <v-main>
      <router-view></router-view>
    </v-main>

    <language-selector @language-selected="onLanguageSelected" />
    <terms-popup @terms-accepted="handleTermsAccepted"></terms-popup>
  </v-app>
</template>

<script>
import TermsPopup from '@/components/TermsPopup.vue';
import LanguageSelector from '@/components/LanguageSelector.vue';
import { getActiveRegionKey } from '@/config/regions';

export default {
  name: 'App',
  components: {
    LanguageSelector,
    TermsPopup
  },
  computed: {
    showStartNewChat() {
      return this.$route.name === 'sales' || this.$route.name === 'support';
    },
    activeRegion() {
      const key = getActiveRegionKey();
      const idx = key.lastIndexOf('_');
      return idx === -1 ? key : key.slice(idx + 1);
    }
  },
  methods: {
    onLanguageSelected() {
      const newLang = this.$i18n.locale;
      const newRegionKey = getActiveRegionKey();
      localStorage.setItem('harvia-language', newLang);
      if (this.$route.query.language !== newLang || this.$route.query.region !== newRegionKey) {
        this.$router
          .replace({ query: { ...this.$route.query, language: newLang, region: newRegionKey } })
          .catch(() => { /* duplicate-navigation is fine */ });
      }
      this.$nextTick(() => {
        this.$root.$emit('show-terms-popup');
      });
    },
    startNewChat() {
      this.$root.$emit('start-new-chat');
    },
    handleTermsAccepted() {
      console.log('Terms accepted');
    },
    showLanguageSelector() {
      this.$root.$emit('show-language-selector');
    }
  }
};
</script>

<style lang="scss">
@import "./sass/commonstyles.scss";
</style>
